import { Button, Col, Grid, Row, Well } from 'react-bootstrap'

import PropTypes from 'prop-types'
import React from 'react'
import map from 'lodash/map'

class SaxsHPLCPlotMenuPanel extends React.Component {
  handleChange = event => {
    this.props.dropdown['UvAbsorption'].uvAbsorptionDataToShow(event.target.value)
  }

  render() {
    let { buttons } = this.props

    return (
      <Well style={{ padding: '5px' }}>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              {map(buttons, button => (
                <span
                  style={{
                    paddingLeft: button.label === 'Scale' ? '20px' : '5px',
                    paddingRight: '5px',
                  }}
                >
                  <MenuButton
                    backgroundColor={button.color}
                    label={button.label}
                    onClick={button.onClick}
                    isButtonPressed={button.isButtonPressed}
                  />
                </span>
              ))}

              {this.props.dropdown &&
                this.props.dropdown['UvAbsorption'] &&
                this.props.dropdown['UvAbsorption'].dataseries && (
                  <span
                    style={{
                      paddingLeft: this.props.scale.label === 'Scale' ? '20px' : '5px',
                      paddingRight: '5px',
                    }}
                  >
                    <MenuButton
                      backgroundColor={this.props.dropdown['UvAbsorption'].color}
                      label={this.props.dropdown['UvAbsorption'].label}
                      onClick={this.props.dropdown['UvAbsorption'].onClick}
                      isButtonPressed={this.props.dropdown['UvAbsorption'].isButtonPressed}
                    />
                  </span>
                )}

              {this.props.dropdown &&
                this.props.dropdown['UvAbsorption'] &&
                this.props.dropdown['UvAbsorption'].dataseries && (
                  <select name="pets" id="pet-select" onChange={this.handleChange}>
                    <option value="" />
                    {Object.entries(this.props.dropdown['UvAbsorption'].dataseries).map(entry => (
                      <option key={entry[0]} value={entry[0]}>
                        {entry[1].label} nm
                      </option>
                    ))}
                  </select>
                )}

              {this.props.scale && (
                <span
                  style={{
                    paddingLeft: this.props.scale.label === 'Scale' ? '20px' : '5px',
                    paddingRight: '5px',
                  }}
                >
                  <MenuButton
                    backgroundColor={this.props.scale.color}
                    label={this.props.scale.label}
                    onClick={this.props.scale.onClick}
                    isButtonPressed={this.props.scale.isButtonPressed}
                  />
                </span>
              )}
            </Col>
          </Row>
        </Grid>
      </Well>
    )
  }
}

export default SaxsHPLCPlotMenuPanel

SaxsHPLCPlotMenuPanel.propTypes = {
  buttons: PropTypes.array,
}

const MenuButton = props => (
  <Button active={props.isButtonPressed === true ? true : false} bsSize="small" onClick={props.onClick}>
    {props.backgroundColor ? (
      <RectangleColorDiv backgroundColor={props.backgroundColor} height="10" width="10" />
    ) : null}
    <span> {props.label} </span>
  </Button>
)

const RectangleColorDiv = props => {
  let { backgroundColor, height, width } = props
  return (
    <div
      style={{
        display: 'inline-block',
        border: '1px solid gray',
        backgroundColor: backgroundColor,
        height: String(height) + 'px',
        width: String(width) + 'px',
      }}
    />
  )
}
